import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { map, Observable, BehaviorSubject } from 'rxjs';
import { MyProfileRepository } from '../repositories/my-profile.repository';
import { CustomerModel } from '../models/customer.model';

@Injectable({
  providedIn: 'root'
})
export class MyProfileService {

  private comissionerSubject: BehaviorSubject<any> = new BehaviorSubject(false); // comissioner subject para mudar modo comissário

  constructor(private myProfileRepository: MyProfileRepository) {
    this.defineModeComissioner(false);
  }

  public saveProfile(editProfileForm: CustomerModel): Observable<CustomerModel> {
    return this.myProfileRepository.saveProfile(editProfileForm);
  }

  generateValidationCode(params: any, captcha: string) {
    return this.myProfileRepository.generateValidationCode(params, captcha);
  }

  sendImage(params: any) {
    return this.myProfileRepository.sendImage(params);
  }

  checkValidationCode(params: any) {
    return this.myProfileRepository.checkValidationCode(params);
  }

  public getComissioner() {
    return this.comissionerSubject.asObservable();
  }

  public getUserFacialValidationImage(userId: string){
    return this.myProfileRepository.getUserFacialValidationImage(userId);
  }


  public defineModeComissioner(comissioner: boolean) {
    this.comissionerSubject.next(comissioner);
  }


  deleteProfile(token: string) {
    return this.myProfileRepository.deleteProfile(token);
  }

  checkToken(token: string, eventId?: string) {
    return this.myProfileRepository.checkToken(token, eventId);
  }

  checkCustomerRegisterWithCpf(doc: any) {
    return this.myProfileRepository.checkCustomerRegisterWithCpf(doc);
  }

  findByDoc(doc: any) {
    return this.myProfileRepository.findByDoc(doc);
  }

}
